import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export interface FabHelpProps {
  label?: string;
  onClick?: () => void;
  hideOn?: "mobile" | "never" | "always";
  className?: string;
}

export function FabHelp({
  label = "UAT Help",
  onClick,
  hideOn = "never",
  className,
}: FabHelpProps) {
  if (hideOn === "always") return null;

  return (
    <div
      className={cn(
        "fixed right-3 bottom-3 sm:right-5 sm:bottom-5 z-40",
        "pb-[env(safe-area-inset-bottom)]",
        hideOn === "mobile" && "hidden sm:block",
        className
      )}
    >
      <button
        type="button"
        onClick={onClick}
        aria-label={label}
        className={cn(
          "group inline-flex items-center gap-2 rounded-full shadow-pop focus-ring",
          "bg-brand-600 text-white hover:bg-brand-700 transition",
          "h-12 w-12 sm:h-auto sm:w-auto sm:px-4 sm:py-2.5",
          "justify-center"
        )}
      >
        <Sparkles className="h-4 w-4 shrink-0" />
        <span className="hidden sm:inline text-sm font-medium">{label}</span>
      </button>
    </div>
  );
}
